import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  Drawer,
  Row,
  Select,
} from "antd";
import { useEffect, useState } from "react";
import "react-phone-input-2/lib/style.css";
import SingleImageUpload from "../../components/SingleImageUpload";
import { Severty, ShowToast } from "../../helper/toast";
import useRequest from "../../hooks/useRequest";
import apiPath from "../../constants/apiPath";
const { RangePicker } = DatePicker;

const allowedImageTypes = [
  "image/png",
  "image/jpg",
  "image/jpeg",
  "image/webp",
];

const AddForm = ({ api, show, hide, data, refresh, calendars = [] }) => {
  const [form] = Form.useForm();
  const { request } = useRequest();
  const [image, setImage] = useState(null);
  const [serviceList, setServiceList] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleImage = (files) => {
    if (files.length > 0) {
      setImage(files[0].url);
      form.setFieldsValue({ image: files[0]?.url || null });
    } else {
      setImage(null);
      form.setFieldsValue({ image: null });
    }
  };

  useEffect(() => {
    if (!data) return;
    setImage(data?.image);
    form.setFieldsValue({
      ...data,
    });
  }, [data]);

  const onCreate = (values) => {
    setLoading(true);
    const payload = {
      ...values,
      image,
    };

    request({
      url: `${data ? `${api.addEdit}/${data._id}` : api.addEdit}`,
      method: "POST",
      data: payload,
      onSuccess: (res) => {
        setLoading(false);
        if (res.status) {
          ShowToast(res.message, Severty.SUCCESS);
          hide();
          refresh();
        } else {
          ShowToast(res.message, Severty.ERROR);
        }
      },
      onError: (error) => {
        setLoading(false);
        ShowToast(error.response?.data?.message, Severty.ERROR);
      },
    });
  };

  const getServices = () => {
    request({
      url: apiPath.serviceList,
      method: "GET",
      onSuccess: ({ data }) => {
        setServiceList(data?.list?.docs || []);
      },
      onError: (error) => {
        ShowToast(error || "Service not Found", Severty.ERROR);
        console.log("error");
      },
    });
  };

  useEffect(() => {
    getServices();
  }, []);

  return (
    <Drawer
      title={`${data ? "Edit" : "Add"} Staff`}
      width={window.innerWidth < 768 ? "100%" : 500}
      onClose={() => {
        hide();
        form.resetFields();
        setImage(null);
      }}
      open={show}
      destroyOnClose
      footer={null}
    >
      <Form form={form} layout="vertical" onFinish={onCreate}>
  {/* Basic Information */}
  <div className="form-section">
    <h3 className="section-title">Basic Information</h3>
    <Form.Item
      label="Staff Name *"
      name="name"
      rules={[{ required: true, message: "Please enter staff name" }]}
    >
      <Input placeholder="Enter staff member's full name" />
    </Form.Item>

    <Form.Item
      label="Profile Image"
      name="image"
      rules={[{ required: true, message: "Please upload staff image" }]}
    >
      <SingleImageUpload
        value={image ? [{ url: image }] : []}
        fileType={allowedImageTypes}
        imageType="image"
        btnName="Upload Image"
        onChange={handleImage}
      />
    </Form.Item>
  </div>

  {/* Services */}
  <div className="form-section">
    <h3 className="section-title">Services *</h3>
    <Form.Item
      name="services"
      rules={[{ required: true, message: "Please select services" }]}
    >
      <Select mode="multiple" placeholder="Select services this staff member can offer">
        {serviceList.map((srv) => (
          <Select.Option key={srv._id} value={srv._id}>
            {srv.name}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  </div>

  {/* Schedule & Availability */}
  <div className="form-section">
    <h3 className="section-title">Schedule & Availability</h3>
    <Form.Item
      label="Business Calendar"
      name="availability"
      rules={[{ required: true, message: "Please select a calendar" }]}
    >
      <Select placeholder="Wellness Schedule">
        {calendars.map((cal) => (
          <Select.Option key={cal._id} value={cal._id}>
            {cal.name}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>

    <Form.Item label="Custom Availability" name="custom_availability">
      <Input.TextArea rows={3} placeholder="e.g., Mon-Fri: 9AM-6PM, Sat: 10AM-4PM" />
    </Form.Item>
  </div>

  {/* Footer */}
  <div className="form-footer">
    <Button onClick={hide}>Cancel</Button>
    <Button type="primary" htmlType="submit" loading={loading}>
      {data ? "Update Staff Member" : "Add Staff Member"}
    </Button>
  </div>
</Form>

    </Drawer>
  );
};

export default AddForm;
